// Ozone colors constants. Use CSS vars or SCSS vars if possible. These should be used in only specific cases

export const blue60 = '#0F62FE';
export const gray80 = '#393939';
export const red60 = '#DA1E28';
export const green60 = '#198038';
export const yellow60 = '#D1A627';
export const purple60 = '#8A3FFC';
export const cyan60 = '#0072C3';
export const teal60 = '#007D79';
export const magenta60 = '#D12771';
export const black = '#000';

export const ozoneColorsArr = [
  red60,
  yellow60,
  magenta60,
  purple60,
  blue60,
  teal60,
  green60,
  gray80,
  black,
];

export const blue40 = '#d0e2ff';
export const gray40 = '#e0e0e0';
export const red40 = '#ffd7d9';
export const green40 = '#a7f0ba';
export const yellow40 = '#fff5d6';
export const purple40 = '#e8daff';
export const cyan40 = '#bae6ff';
export const teal40 = '#9ef0f0';
export const magenta40 = '#ffd6e8';
export const ozoneColorsArr40 = [
  red40,
  yellow40,
  magenta40,
  purple40,
  blue40,
  teal40,
  green40,
  cyan40,
];
